export const getCategoryIndex = (programNumber: number) =>
  Math.floor(programNumber / 8)

export const categoryEmojis = [
  "🎹",
  "🔔",
  "🎹",
  "🎸",
  "🎸",
  "🎻",
  "🧑‍🤝‍🧑",
  "🎺",
  "🎷",
  "🍾",
  "🕹️",
  "🔮",
  "⚡",
  "🍛",
  "🥁",
  "🚁",
]
